import { BaseCommand } from './commands';
import { ESimSmartDetailedBarUnbarCommand } from './ESimSmartDetailedBarUnbarCommand';

export class ESimSmartDetailedUnbarCommand extends ESimSmartDetailedBarUnbarCommand {
  public definitionAlias: 'esimsmart-detailed-unbar' = 'esimsmart-detailed-unbar';
  constructor(command: BaseCommand) {
    super(command);
  }
}
